/**
 * どのキャンペーン窓で店を見せるかを決める。
 *
 * 店には2つの見せ方がある:
 *
 *   public    誰にでも見える。10月の一般販売を待たずに予約できる、という案内。割引なし。
 *   campaign  合言葉つきのリンクから来た人にだけ見える。締切・カウントダウン・割引つき。
 *
 * Liquid はクエリパラメータを読めない（Shopify の request オブジェクトに
 * query_string が無い）。ページはフルページキャッシュにも載る。だから窓の判定は
 * **必ずブラウザ側**でやる必要がある。サーバは両方の窓を書き出しておいて、
 * ここで片方を消す。
 *
 * 重要なのは「消す」対象の非対称性:
 *
 *   - public 側は既定で表示。JS が動かない環境でも、店は必ず何かを売っている。
 *   - campaign 側は既定で hidden。JS が動かなければ割引案内は出ない。
 *
 * 逆にすると、JS が失敗した人全員に割引が見えてしまう。合言葉の意味が無くなる方向に
 * 壊れるより、何も起きない方向に壊れるほうがいい。
 *
 * **値段そのものはここで守っていない。** 表示を切り替えるだけ。実際の価格は Shopify の
 * 割引コードリンク（/discount/CODE?redirect=...）が決める。つまりソースを読んで合言葉を
 * 見つけても、割引コードを持っていなければ安く買えない。表示の門と価格の門は別物で、
 * 価格の門のほうが本物。
 */
(function () {
  var root = document.documentElement;
  var cfg = root.getAttribute('data-senkou-config');
  if (!cfg) return;

  var conf;
  try {
    conf = JSON.parse(cfg);
  } catch (e) {
    return; // 壊れた設定なら public のまま。既定が安全側なのでこれでいい。
  }

  var KEY = 'senkou-window-v1';
  var TTL_DAYS = 30;

  function readStored() {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return null;
      var v = JSON.parse(raw);
      if (!v || !v.key || !v.at) return null;
      if (Date.now() - v.at > TTL_DAYS * 86400000) return null;
      return v.key;
    } catch (e) {
      return null;
    }
  }

  function store(key) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify({ key: key, at: Date.now() }));
    } catch (e) {
      /* プライベートブラウジング。今回のページだけ効けばいい。 */
    }
  }

  // 合言葉はリンクに1回しか乗らない。LINE から来て商品ページを回遊した時点で
  // パラメータは落ちるので、一度受け取ったら憶えておく必要がある。
  var param = null;
  try {
    param = new URLSearchParams(window.location.search).get('campaign');
  } catch (e) {
    param = null;
  }
  if (param) store(param);

  var given = param || readStored();
  var live = conf.campaignKey && given && given === conf.campaignKey;

  // 締切を過ぎていれば合言葉があっても campaign 窓は開けない。締切が本当に締切で
  // あることは、合言葉を持っている人にとっても同じ。
  if (live && conf.cutoff) {
    var cutoffMs = new Date(conf.cutoff).getTime();
    if (!isNaN(cutoffMs) && Date.now() >= cutoffMs) live = false;
  }

  // 属性は**同期で**立てる。セクションのインラインスクリプト（バー・ポップアップ）は
  // 自分が描画された時点でこれを読むので、head で走るこのファイルより後になる。
  root.setAttribute('data-senkou-window', live ? 'campaign' : 'public');

  var show = live ? 'campaign' : 'public';

  // ブロックの入れ替えは DOM ができてから。head で走る時点では body が無く、
  // querySelectorAll は空を返す——最初の実装がこれで、属性だけ切り替わって
  // カードは public のままだった（バーだけ campaign になり、本文は定価のまま）。
  function swap() {
    var blocks = document.querySelectorAll('[data-senkou-window]');
    for (var i = 0; i < blocks.length; i++) {
      var el = blocks[i];
      if (el === root) continue;
      var mine = el.getAttribute('data-senkou-window');
      if (mine === show) {
        el.hidden = false;
      } else if (mine === 'campaign' || mine === 'public') {
        el.hidden = true;
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', swap);
  } else {
    swap();
  }

  // 合言葉を持っている人だけが見るもの（バー・ポップアップ）は、この属性を見て
  // 自分で判断する。ここから直接触らないのは、それぞれが自分の閉じる条件
  // （localStorage の snooze 等）を持っているから。
  root.dispatchEvent(new CustomEvent('senkou:window', { detail: { window: show } }));
})();
